import { useEffect, useState }  from 'react';
import FarolList                from './FarolList'
import { useFarol }             from '../../contexts/FarolPageContext';
import { toSelectOptions }      from '../../utils/reactUtils';
import api                      from '../../services/api.js';

const FarolListContainer = ({ faroTerminalId, farols, hasPermission, isAddingFarol, onAddingFarolDone }) => {

    const { handleUpdateFarolCards } = useFarol()

    const [ _editingFarolId, _setEditingFarolId ] = useState(null)
    const [ _options,        _setOptions        ] = useState(null)

    // Opções dos selects (as moegas dependem do terminal); carregadas na primeira edição do card.
    const _loadOptions = async () => {

        if (_options) return

        const response = await api.get(`/getFarolFormData/${faroTerminalId}`)
        const { restriction, products, clients, categories, hoopers } = response.data

        _setOptions({
            restrictions:   toSelectOptions(restriction),
            products:       toSelectOptions(products),
            clients:        toSelectOptions(clients),
            categories:     toSelectOptions(categories),
            hoopers:        toSelectOptions(hoopers),
        })
    }

    useEffect(() => {

        if (!isAddingFarol) return

        _loadOptions().catch(error => {
            console.error('Erro ao carregar opções do farol:', error)
            onAddingFarolDone()
        })

    // Só reage ao clique em "Adicionar"; as funções mudam a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAddingFarol])

    const _handleStartEdit = async (farolId) => {

        // Uma linha em edição por vez em cada card.
        if (!hasPermission || _editingFarolId || isAddingFarol) return

        try {
            await _loadOptions()
            _setEditingFarolId(farolId)
        } catch (error) {
            console.error('Erro ao carregar opções do farol:', error)
        }
    }

    const _handleCancel = (farolId) => {
        farolId ? _setEditingFarolId(null) : onAddingFarolDone()
    }

    // Devolve a mensagem de erro para a linha continuar aberta, ou null se salvou.
    const _handleSave = async (farolId, farolData) => {

        try {

            farolId
                ? await api.put(`/updateFarol/${farolId}`, { farolData })
                : await api.post(`/createFarol/${faroTerminalId}`, { farolData })

            _handleCancel(farolId)
            handleUpdateFarolCards()
            return null

        } catch (error) {
            return error.response?.data?.error || 'Não foi possível salvar.'
        }
    }

    const _handleDelete = async (farolId) => {

        try {

            await api.delete(`/deleteFarol/${farolId}`)
            _setEditingFarolId(null)
            handleUpdateFarolCards()

        } catch (error) {
            console.error('Erro ao excluir farol:', error)
        }
    }

    return (

        <FarolList

            farols={farols}
            hasPermission={hasPermission}

            editingFarolId={_editingFarolId}
            isAddingFarol={isAddingFarol && !!_options}
            options={_options}

            handleStartEdit={_handleStartEdit}
            handleSave={_handleSave}
            handleCancel={_handleCancel}
            handleDelete={_handleDelete}

        />

    )
}

export default FarolListContainer;
